<!-- ============================================================== -->
<!-- Main wrapper -->
<!-- ============================================================== -->
<div class="main-container h-100">
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
    <!-- Sidebar -->
    <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="!mobileQuery.matches">
      <app-sidebar *ngIf="isMobile == true" [isMobileActive]="isMobile" (messageEvent)="receiveMessage($event)"
        (click)="snav.close()"></app-sidebar>
      <app-sidebar *ngIf="isMobile == false"></app-sidebar>
    </mat-sidenav>

    <!-- Page container -->
    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <div class="row m-0 p-0 w-100 justify-content-between">
          <!-- Navigation/Sidebar toggle -->
          <div class="row col-xs-1 align-items-center">
            <a style="cursor: pointer; margin-left:5px;" (click)="snav.toggle(); WindowResize($event)">
              <div class="fa fa-chevron-right rotate" style="color: black"></div>
            </a>
            <p class="pl-1 p-0">{{ navName }}</p>
          </div>

          <!-- Right navigation -->
          <div class="col-xs-11 p-0 rightdiv">
            <div class="row">
              <!-- Notification bell and dropdown -->
              <span style="position: relative; display: inline-block;">
                <i class="fas fa-bell bellIcon" (click)="openNotifications()" style="cursor:pointer;"></i>
                <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>

                <div *ngIf="showNotificationDropdown" class="notification-dropdown">
                  <div class="notification-header">
                    <span>Notifications</span>
                    <div>
                      <!-- <button (click)="markAllAsRead()" class="btn-link2" [disabled]="isMarkingRead"
                        [ngStyle]="{ color: unreadCount > 0 && !isMarkingRead ? '#C9B25E' : '#000' }">
                        <ng-container *ngIf="!isMarkingRead">Read All</ng-container>
                        <ng-container *ngIf="isMarkingRead">
                          <ngx-spinner type="ball-scale-multiple" size="medium" color="#fff"></ngx-spinner>
                          Marking...
                        </ng-container>
                      </button> -->
                    </div>
                  </div>

                  <ul class="notification-list">
                    <li *ngFor="let n of notifications" (click)="onNotificationClick(n)" style="cursor: pointer;">
                      <span [ngStyle]="{
                              'font-weight': !n.isRead ? '700' : '400',
                              color: !n.isRead ? '#424242' : '#000'
                            }">
                        {{ n.message }}
                      </span>
                      <small class="notification-time">{{ formatNotificationTime(n.insertDate) }}</small>
                    </li>
                    <li *ngIf="notifications.length === 0">No notifications.</li>
                  </ul>
                </div>
              </span>

              <!-- Logout -->
              <span>
                Logout
                <i class="fas fa-power-off signoutIcon position-relative ml-1 mt-2" style="cursor: pointer;" #suspendBtn
                  (click)="openModal(modalsuspend,suspendBtn)" mat-icon-button> </i>
              </span>

              <!-- Profile menu (hidden code, for reference) -->
              <mat-menu #profile="matMenu" class="mymegamenu">
                <button *ngIf="userRole == 'manager' || userRole == 'employee' || userRole == 'admin'"
                  (click)="changePasswordNav()" mat-menu-item>
                  <mat-icon [style.color]="'#0C479D'">no_encryption</mat-icon>
                  Change Password
                </button>
                <button (click)="logoutUser()" mat-menu-item>
                  <mat-icon [style.color]="'#0C479D'">exit_to_app</mat-icon>
                  Sign Out
                </button>
              </mat-menu>
            </div>
          </div>
        </div>

        <!-- Page content and outlet -->
        <main>
          <router-outlet #page="outlet"></router-outlet>
        </main>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- Logout Modal Template -->
<ng-template #modalsuspend let-modal>
  <div class="modal-body">
    <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
    <div class="row mt-3 col-md-12 justify-content-center m-0 p-0">
      <p class="_modal_text">Are you sure?</p>
      <p class="_modal_text">You want to Logout!</p>
    </div>
    <div class="row mt-3 col-md-12 justify-content-center m-0 p-0">
      <button (click)="logoutUser()" class="w-50 btn addCandidateBtn">Yes</button>
    </div>
    <div class="row mt-2 col-md-12 justify-content-center m-0 p-0">
      <button (click)="modal.dismiss('Cross click')" class="w-50 btn addCandidateBtn">No</button>
    </div>
  </div>
</ng-template>